import { message, Modal } from "antd";
import { useTranslation } from "react-i18next";
import { useAddUserMutation, useChangePassworUserMutation, useDeleteUserMutation, useEditUserMutation } from "../../../redux/api/userApis/usersApi";
import { EntUser } from "../../../models/user";
import { NewPass } from "../../../models/newPass";
import { getCookie } from "typescript-cookie";


const useUsers = (modal: any, refresh?: () => void) => {
    const { t } = useTranslation()
    const { confirm } = modal;
    const [addUser] = useAddUserMutation();
    const [deleteUser] = useDeleteUserMutation();
    const [editUser] = useEditUserMutation();
    const [changePass] = useChangePassworUserMutation();

    async function onAddUser(newUser: EntUser): Promise<boolean> {
        try {
            let status: boolean = false;
    
            await addUser(newUser).then((response: any) => {
                if (response.error) {
                    const isKyrgyz = getCookie('i18next') === 'ky';
                    const lang = isKyrgyz ? 'kg' : 'ru';
                    const res = response.error.data?.res;
                    const errorMessages = Array.isArray(res)
                      ? res.map((error: any) => error[lang] || error.ru).join('\n')
                : response.error.data?.msg || t('unknownError');
                    throw new Error(errorMessages);
                }
                if (response.data?.success) {
                    status = true;
                    message.success(t('msg.successAdd'));
                    if (refresh) refresh();
                }
            }).catch((error: any) => {
                modal.error({
                    title: t('msg.error'),
                    content: error.message, 
                });
            });
    
            return status;
        } catch (error: any) {
            modal.error({
                title: t('msg.error'),
                content: error.message || t('unknownError'),
            });
            return false;
        }
    }
    async function onChangePass(newPass: NewPass): Promise<boolean> {
        try {
            let status: boolean = false;
            await changePass(newPass).then((response: any) => {
                if (response.error) {
                    const isKyrgyz = getCookie('i18next') === 'ky';
                    const lang = isKyrgyz ? 'kg' : 'ru';
                    const res = response.error.data?.res;
                    const errorMessages = Array.isArray(res)
                        ? res.map((error: any) => error[lang] || error.ru).join('\n')
                        : response.error.data?.msg || t('unknownError'); 
                    throw new Error(errorMessages);
                }
                if (response.data.success) {
                    status = true;
                    message.success(t('msg.successAdd'));
                    if(refresh) refresh();
                }
            }).catch((error:any) => {
                modal.error({ title: t('msg.error'), content: String(error.message) });
          
            });
            return status;
        } catch (error: any) {
            modal.error({ title: t('msg.error'), content: String(error.message) });
            return false;
        }
    }
    async function onDeleteUser(user: EntUser) {
        try {
            let status: boolean = false;
            confirm({
                centered: true,
                title: t('msg.confirmDeleteText'),
                okText: t('general.yes'),
                cancelText: t('general.no'),
                onOk() {
                    deleteUser(user.id).then((response: any) => {
                        if (response.error) {
                            const isKyrgyz = getCookie('i18next') === 'ky';
                            const lang = isKyrgyz ? 'kg' : 'ru';
                            const res = response.error.data?.res;
                            const errorMessages = Array.isArray(res)
                                ? res.map((error: any) => error[lang] || error.ru).join('\n')
                                : response.error.data?.msg || t('unknownError'); 
                            throw new Error(errorMessages);
                        }
                        if (response.data.success) {
                            status = true;
                            Modal.success({title: t('msg.successDelete')});
                            if(refresh) refresh();
                        }
                    }).catch((error) => {
                        Modal.error({ title: t('msg.error'), content: String(error.message) });
                        
                    });
                }
            })
            return status
        } catch (error: any) {
            Modal.error({ title: t("msg.error"), content: String(error.message) });
            return false;
        }
    };
    async function onEditUser(editedUser: EntUser): Promise<boolean> {
        try {
            let status: boolean = false;
            await editUser(editedUser).then((response: any) => {
                if (response.error) {
                    const isKyrgyz = getCookie('i18next') === 'ky';
                    const lang = isKyrgyz ? 'kg' : 'ru';
                    const res = response.error.data?.res;
                    const errorMessages = Array.isArray(res)
                      ? res.map((error: any) => error[lang] || error.ru).join('\n')
                      : response.error.data?.msg || t('unknownError');
                    throw new Error(errorMessages);
                }
                if (response.data.success) {
                    status = true;
                    Modal.success({title: t('msg.successEdited')});
                    if(refresh) refresh();
                }
            }).catch((error: any) => {
                Modal.error({ title: t('msg.error'), content: String(error.message) });
            });
            return status;
        } catch (error: any) {
            Modal.error({ title: t("msg.error"), content: String(error.message) });
            return false;
        }
    };
    return { onAddUser,onDeleteUser, onEditUser, onChangePass }

}
export { useUsers };

